import { useLocation, useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes, { MainRoutesAdmin, MainRoutesBeta } from './MainRoutes';
import useAuth from '../hooks/useAuth';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  // Google analytics routing tracker START
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
  // Google analytics routing tracker END

  const { user } = useAuth();
  const routes = [LoginRoutes];
  if (user && user?.isAdminUser) {
    routes.push(MainRoutesAdmin);
  } else if (user && user?.isBetaUser) {
    routes.push(MainRoutesBeta);
  } else {
    routes.push(MainRoutes);
  }
  return useRoutes(routes);
}
